var _ellipse, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboardIconWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.9998,
    cy: 17.5,
    rx: 16.9998,
    ry: 17.5,
    fill: "#F2F7F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.25195 15.08C9.25195 14.3567 9.59734 13.6796 10.1758 13.269L16.999 8.4248L23.8223 13.269C24.4007 13.6796 24.7461 14.3567 24.7461 15.08V24.3748C24.7461 25.5898 23.7893 26.5748 22.609 26.5748H11.3891C10.2088 26.5748 9.25195 25.5898 9.25195 24.3748V15.08Z",
    stroke: "#20ACD9",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5948 20.5248C14.5948 19.9173 15.0732 19.4248 15.6633 19.4248H18.3347C18.9249 19.4248 19.4033 19.9173 19.4033 20.5248V26.5748H14.5948V20.5248Z",
    stroke: "#20ACD9",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIconWhite);
export default __webpack_public_path__ + "static/media/dashboard-icon-white.9cb2b689e0eab40a74d6aeac2b11b399.svg";
export { ForwardRef as ReactComponent };